import React, { Component } from 'react';

import {getMiniatureFromAideName} from './Miniatures';

import Publicodes from 'publicodes';
import axios from 'axios';
import yaml from 'yaml';
import aides from './aides.yaml';
import epci from '@etalab/decoupage-administratif/data/epci.json';

class Aidesvelo extends Component {
	state = { 
		data: this.props.d ,
		result : [],
		loading: false,
		detail: {}

	};

  setDetail = (id) => {
    // Inverser l'état de l'élément de détail spécifique
    this.setState((prevState) => ({
      detail: {
        ...prevState.detail,
        [id]: !prevState.detail[id] // Inverser l'état actuel
      }
    }));
  };


	componentDidMount() {

		
		// Start loading animation 
		this.setState({loading:true});


		const rfr  = parseInt(this.state.data?.rfr) * 12 ;

		//const code =  this.state.data.codePostal ;

		/* Chargement des region et localite */

		var localite = this.state.data?.localite;
		var departement = "";


		if ( typeof this.state.data?.codePostal !==  'undefined' ) {
			departement = this.state.data.codePostal.slice(0,2);
		}

		const codeInsee = this.state.data?.codeInsee;
		const codeEpci = this.state.data?.codeEpci;
		const siren  = this.state.data?.siren;
		const region = this.state.data?.region;	

		// Get correct format for epci.
		if ( typeof codeEpci !== 'undefined') { 
			localite = (epci.filter( (ep) => ( ep.code === codeEpci)))[0].nom ; 
		}
		// Get correct format for region .
		if ( typeof region !== 'undefined' ) {

		}
		// Get correct format for department .
		if ( typeof siren !== 'undefined') {

		}
		// 



		const veloType  = this.state.data?.velo.type;
		const veloPrice = parseInt(this.state.data?.velo.price);
		const veloEtat  = "neuf";

		const imposable  = (rfr < 16372 ) ? "'non'" : "'oui'";
		
		axios.get(aides)
			.then(response => {
				const parsedData = yaml.parse(response.data);

				const engine = new Publicodes(parsedData);

        /* creation du contexte publicodes */   
				const context = {

				    'revenu fiscal de référence par part' : rfr + ' €/an',
				    'vélo . type': ""+veloType+"",
				    'vélo . prix': veloPrice ,
				    'vélo . état': "'"+veloEtat+"'",
				    'localisation . code insee' : "'"+codeInsee+"'",
				    'localisation . epci' : "'"+localite+"'",
				    'localisation . région' : "'"+region+"'",
				    'localisation . département' : "'"+departement+"'",
				    'maximiser les aides' : 'non'
			    };
			  

				
				engine.setSituation(context);

				let items = [];
				const rules = engine.getParsedRules();

        Object.entries(rules).forEach(([nom, rule]) => {
					

					let aide = { id : rule.dottedName , url : rule.rawNode.lien};
							
					var keywords = [ 'aides .'];
					var regex = new RegExp(keywords.join('|'), 'i');

					if (regex.test(aide.id) && aide.id != "undefined" && aide.url != "undefined" && aide.id != 'aides . état' ) {
						let t = engine.setSituation(context).evaluate(aide.id);

						let text = {};


						if(t.nodeValue > 1 
							&& t.title !== 'Montant'
							&& t.title !== 'Prime à la conversion'
							&& t.title !== 'Forfait mobilités durables'
							&& t.title !== 'Prix vélo'
							&& t.title !== '$plafond'
							&& typeof(t.title) !== 'undefined'
						){
						
						
							text.title = t.title + ' : ';
							text.prix = t.nodeValue.toFixed(0).toString();
							text.miniature = getMiniatureFromAideName(aide.id);
						    if(t.unit){
						        text.unit = ' '+t.unit.numerators+t.unit.denominators;
						    }
						    //text.desc = aide.description;
						    text.url = aide.url
						    items.push(text);
						    
						}
					}


				});
			this.setState(
				{
					result: items,
					loading: false, // end loading animation
			 	}
			 );
				  
		})
		.catch(error => {
			console.error('Erreur lors du chargement du fichier YAML :', error);
		});
	}

	render() {
        const { result, loading, detail } = this.state;

		if (!this.state.loading ) {
			return  (this.state.result.length) ? (
					<>
					<div className="categorie aide-velo">
						<h4>Aide(s) à l'achats d'un vélo </h4>
						{this.state.result.map((item, index) => (
						<div>
							<div className="droit aides-velo">
								<div className="cell-left">
									<img className="droit-img"
									  width="100"
									  height="100"
									  src={item.miniature}
									  alt="{item.miniature}"
									/>
									<span>{item.title.slice(0,-2)}</span>
								</div>
								<div className="cell-right">
									<div className="button-container">
										<a href={item.url} target="_blank" rel="noreferrer">
											<button className="btn-obtenir">En savoir plus</button>
										</a>
									</div>
									<span><strong> {item.prix}  €</strong></span>
									<span className="mobile-only btn-show" onClick={() => this.setDetail(item.url)}>
                      <i className={detail[item.id] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
                    </span>
								</div>

							</div>
              {detail[item.url] && (
                  <div className="droit-details fade-in">
                    <a href={item.url} target="_blank" rel="noreferrer">
                      <button className="btn-obtenir mobile-only">Comment l'obtenir ?</button>
                    </a>
                  </div>
                )}
						</div>

						))}

						
					</div>
					

					<hr className="droit-separation"/>
					</>
				) : (<div></div>)
			;
		}
	}
}

export default Aidesvelo;
